// Generic horizontal slider behaviour.
// Markup contract (set via data-* so multiple carousels can opt in):
//   <div data-slider>
//     <ul data-slider-track>           ← the scroll-snap-x scroller
//       <li>…</li>
//     </ul>
//     <button data-slider-prev></button>     (optional)
//     <button data-slider-next></button>     (optional)
//     <div data-slider-progress></div>       (optional — receives --progress)
//   </div>
//
// No deps. No animations beyond native smooth-scroll. CSS still owns layout/snap.

(() => {
  const init = (root) => {
    const track = root.querySelector("[data-slider-track]");
    if (!track) return;
    const prev = root.querySelector("[data-slider-prev]");
    const next = root.querySelector("[data-slider-next]");
    const progress = root.querySelector("[data-slider-progress]");

    const stepSize = () => {
      const card = track.firstElementChild;
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      return card.getBoundingClientRect().width + gap;
    };

    const scrollByStep = (dir) => {
      track.scrollBy({ left: dir * stepSize(), behavior: "smooth" });
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      const ratio = max > 0 ? Math.min(1, Math.max(0, track.scrollLeft / max)) : 1;
      if (progress) progress.style.setProperty("--progress", (ratio * 100).toFixed(2) + "%");
      if (prev) prev.toggleAttribute("disabled", track.scrollLeft <= 1);
      if (next) next.toggleAttribute("disabled", track.scrollLeft >= max - 1);
    };

    prev?.addEventListener("click", () => scrollByStep(-1));
    next?.addEventListener("click", () => scrollByStep(1));
    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    // run after layout settles (images may shift widths)
    requestAnimationFrame(update);
  };

  const boot = () => document.querySelectorAll("[data-slider]").forEach(init);
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();
